<template>
  <div class="v_all_all">
    <div class="v_all_background" v-if="haveData == 1">
      <!-- <el-input v-model="b"></el-input> -->
      <div class="v_all_title">
        <div class="v_all_title_text">上传内容</div>
        <div class="v_all_title_text_another">上传结果</div>
        <div class="v_all_title_text_another">当前位置</div>
      </div>
      <div class="v_all_middle" id="scrollRecord">
        <div  v-for="(item, i) in list" :key="i">
          <div class="v_all_middle_item">
            <div class="v_item_item">
              <div class="v_item_item_left">
                <img class="iv_img" :src="item.photoUrl" alt="">
                <div class="v_item_item_left_text">{{ item.type == 1 ? '' : '视频' }}</div>
              </div>
              <div class="v_img_name">{{ item.title }}</div>
            </div>
            <div class="v_item_item_another">{{ item.content }}</div>
            <div class="v_item_item_another">{{ item.photoCategoryNameNew }}</div>
          </div>
          <div class="v_line" v-if="i != list.length-1"></div>
        </div>
      </div>
    </div>
    <div class="v_have_no_data" v-if="haveData == 2">
      <img class="iv_have_no_box" src="@/assets/images/personal/iv_have_no_box.png" alt="">
      <div class="iv_have_no_text">暂无</div>
    </div>
  </div>
</template>

<script>
import {
  catchErr
} from "@/utils/utils";
import {
  _findUploadByDmId
} from "@/api/Space";
window.onload = function () {
  document.addEventListener("touchstart", function (event) {
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  });
  document.addEventListener("gesturestart", function (event) {
    event.preventDefault();
  });
};
export default {
  data() {
    return {
      b: '',
      haveData: 1,
      list: [],
      scrollRecord: "",
      isCanNext: true,
      pageInfo: {
        page: 1,
        size: 10,
        total: 0
      }
    }
  },
  created() {
    this.findUploadByDmId()
  },
  mounted() {
    //获取节点
    this.scrollRecord = document.getElementById("scrollRecord");
    //绑定事件
    this.scrollRecord.addEventListener("scroll", this.handleScroll);
  },
  methods: {

    async findUploadByDmId() {
      let that = this;
      let data = {
        dmId: that.$route.query.id,
        createAdminName: ""
      }
      let [err, res] = await catchErr(
        _findUploadByDmId(
          {
            data: data,
            pageInfo: that.pageInfo
          },
          that.$route.query.id
        )
      );
      if (err) {
      } else {
        console.log(res)
        that.isCanNext = true
        that.pageInfo = res.pageInfo
        res.data.forEach((_t) => {
          _t.photoCategoryNameNew = _t.photoCategoryName != undefined ? _t.photoCategoryName : '—'
          if (_t.state == 2) {
            _t.content = 'C端删除'
          } else if (_t.movePhotoCategorySystem == 1) {
            _t.content = '移出系统相册'
            _t.photoCategoryNameNew = '非系统相册'
          } else {
            _t.content = '上传成功'
          }
          if (_t.type == 1) {
            _t.photoUrl = _t.photoUrl + '?x-oss-process=image/resize,m_fill,h_40,w_40'
          } else {
            _t.photoUrl = _t.photoUrl + '?x-oss-process=video/snapshot,t_1000,f_jpg,w_40,h_40,m_fast'
          }
        })
        //that.b = JSON.stringify(res.data)
        that.list = that.list.concat(res.data)
        if (res.data.length == 0 && that.list.length == 0) {
          that.haveData = 2
        } else {
          that.haveData = 1
        }
      }
    },


    //滚动事件的监听处理
    handleScroll() {
      const that = this;
      if (
        this.scrollRecord.scrollHeight <=
        this.scrollRecord.scrollTop + this.scrollRecord.offsetHeight
      ) {
        //加载更多
        this.toAddMore();
      }
    },
    toAddMore() {
      if (this.isCanNext && this.list.length < this.pageInfo.total) {
        this.isCanNext = false
        this.pageInfo.page = this.pageInfo.page + 1
        this.findUploadByDmId()
      } else {
        console.log("到底了");
      }
    },
  },
  //移除滚动条监听
  destroyed() {
    this.scrollRecord.removeEventListener("scroll", this.handleScroll);
  },
}
</script>

<style lang="stylus" scoped>

.v_all_all {
  background-color: #F7F8F9;
}

.v_all_background {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  background-color: #ffffff;

  &::-webkit-scrollbar {
    display: none;
  }
}

.v_all_title {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 56px;
  line-height: 56px;
  border-bottom: #D5D5D5 1px solid;
}

.v_all_title_text {
  font-size: 16px;
  font-weight: 400;
  color: #000000;
  flex-grow: 1;
  flex-shrink: 0;
  margin-left: 17px;
}

.v_all_title_text_another {
  font-size: 16px;
  font-weight: 400;
  color: #000000;
  flex-grow: 1;
  flex-shrink: 0;
}

.v_all_middle {
  position: fixed
  left: 0;
  right: 0;
  top: 57px;
  bottom: 0;
  overflow-x: hidden;
  overflow-y: scroll;
  background-color: #ffffff;

  &::-webkit-scrollbar {
    display: none;
  }
}

.v_all_middle_item {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 122px;
}

.v_item_item {
  flex-grow: 1;
  margin-left: 17px;
  flex-shrink: 0;
  flex-basis: 0;
  overflow: hidden;
}

.v_item_item_another {
  flex-grow: 1;
  flex-shrink: 0;
  flex-basis: 0;
  overflow: hidden;
}

.iv_img {
  width: 40px;
  height: 40px;
  border-radius: 5px;
}

.v_item_item_left {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.v_item_item_left_text {
  margin-left: 5px;
  font-size: 10px;
}

.v_img_name {
  font-size: 15px;
  font-weight: 400;
  color: #000000;
  margin-top: 5px;
  overflow:hidden;
  text-overflow:ellipsis;
  display:-webkit-box;
  -webkit-box-orient:vertical;
  -webkit-line-clamp:2;
  margin-right: 20px;
  word-wrap: break-word;
  word-break: break-all;
}

.v_line {
  margin-left: 17px;
  margin-right: 17px;
  height: 1px;
  background-color: #D5D5D5;
}

.v_have_no_data {
  position: fixed;
  left: 0;
  right: 0;
  top: 10px;
  bottom: 0;
  background-color: #F7F8F9;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .iv_have_no_box {
    width: 125px;
    height: 88px;
  }

  .iv_have_no_text {
    color: #949494;
    font-weight: 400;
    font-size: 15px;
    margin-top: 26px;
  }
}

</style>


// WEBPACK FOOTER //
// src/pages/UpdateRecord/UpdateRecord.vue